import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import DeliveryDiscrepancyTable from 'components/partials/stock-location/stocks/delivery-discrepancy/DeliveryDiscrepancyTable';
import InputDatePicker from 'components/pages/customer-service/action-plans/create-action-plan/InputDatePicker';
import { search } from 'services/stock-location/discrepancyService';
import { usePaginationBe } from 'hooks/useBeHandle';
import { BaseTableRQ } from 'components/common/models/BaseClass';

export default function DeliveryDiscrepancyDashboard() {
  // --- Live paging ---
  const [livePaging, setLivePaging] = useState({ ...new BaseTableRQ(1, 2147483647), isGetAll: true });
  const [liveTotal, setLiveTotal] = useState(0);
  const [liveData, setLiveData] = useState([]);

  // --- Historic paging ---
  const [historicPaging, setHistoricPaging] = useState({
    ...new BaseTableRQ(1, 2147483647), isGetAll: true
  });
  const [historicTotal, setHistoricTotal] = useState(0);
  const [historicData, setHistoricData] = useState([]);

  // --- Filter ---
  const [filterHis, setFilterHis] = useState({});
  const [filterLive, setFilterLive] = useState({});

  useEffect(() => {
    loadLiveData(livePaging);
  }, []);

  const loadLiveData = pagingRq => {
    search(pagingRq)
      .then(res => {
        if (res) {
          setLiveData(res.items);
          setLiveTotal(res.total);
          let cl = {
            ...pagingRq,
            status: 0
          };
          setLivePaging(cl);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setLivePaging(pagingRq);
  };

  const {
    gotoPage: liveGotoPage,
    nextPage: liveNextPage,
    previousPage: livePreviousPage
  } = usePaginationBe(
    livePaging,
    liveTotal,
    loadLiveData,
    filterLive,
    setFilterLive
  );

  const loadHistoricData = pagingRq => {
    console.log(pagingRq);
    let mapRq = { ...pagingRq, status: 1 };
    if (pagingRq?.dateFrom && pagingRq?.dateFrom instanceof Date) {
      mapRq.dateFrom = pagingRq?.dateFrom?.toISOString();
    }
    if (pagingRq?.dateTo && pagingRq?.dateTo instanceof Date) {
      mapRq.dateTo = pagingRq?.dateTo?.toISOString();
    }
    search(mapRq)
      .then(res => {
        if (res) {
          setHistoricData(res.items);
          setHistoricTotal(res.total);
          let cl = {
            ...pagingRq,
            status: 1
          };
          setHistoricPaging(cl);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setHistoricPaging(mapRq);
  };

  const {
    gotoPage: hisGotoPage,
    nextPage: hisNextPage,
    previousPage: hisPreviousPage
  } = usePaginationBe(
    historicPaging,
    historicTotal,
    loadHistoricData,
    filterHis,
    setFilterHis
  );

  const handleSearchHistoric = () => {
    console.log(historicPaging);
    loadHistoricData({ ...historicPaging, ...filterHis });
  };

  const handleSearchLives = () => {
    console.log(livePaging);
    loadLiveData({ ...livePaging, ...filterLive });
  };

  return (
    <>
      <PageHeader
        title="Delivery Discrepancy Dashboard"
        description="Manage and review delivery discrepancies."
        className="mb-3"
      />

      {/* Live Section */}
      <Card className="mb-4">
        <Card.Header>
          <h5 className="mb-3">Live Discrepancies</h5>
          {/* Filter form */}
          <Form>
            {/* Supplier name */}
            <Row className="mb-3">
              <Col md={1} className="d-flex align-items-center">
                <label className="form-label mb-0">Supplier name</label>
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Enter supplier..."
                  value={filterLive.supplierName}
                  onChange={e =>
                    setFilterLive({ ...filterLive, supplierName: e.target.value })
                  }
                />
              </Col>
            </Row>

            {/* WPO ref */}
            <Row className="mb-2">
              <Col md={1} className="d-flex align-items-center">
                <label className="form-label mb-0">WPO Ref</label>
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Enter WPO ref..."
                  value={filterLive.wpoRef}
                  onChange={e =>
                    setFilterLive({ ...filterLive, wpoRef: e.target.value })
                  }
                />
              </Col>
            </Row>
            {/* Search button */}
            <Row>
              <Col md={2}>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleSearchLives}
                >
                  Search
                </button>
              </Col>
            </Row>
          </Form>
        </Card.Header>
        <Card.Body className="p-2">
          <DeliveryDiscrepancyTable
            mode="live"
            data={liveData}
            paging={livePaging}
            total={liveTotal}
            nextPage={liveNextPage}
            gotoPage={liveGotoPage}
            previousPage={livePreviousPage}
            reloadFn={() => {
              loadLiveData({ ...livePaging, pageNum: 1 });
              loadHistoricData({ ...historicPaging, pageNum: 1 });
            }}
          />
        </Card.Body>
      </Card>

      {/* Historic Section */}
      <Card>
        <Card.Header>
          <h5 className="mb-3">Historic Discrepancies</h5>

          {/* Filter form */}
          <Form>
            <Row className="mb-2">
              <Col md={1} className="d-flex align-items-center">
                <label className="form-label mb-0">Date raised</label>
              </Col>
              <Col md={2}>
                <InputDatePicker
                  column="dateFrom"
                  selected={filterHis.dateFrom}
                  handleChange={(col, value) => {
                    setFilterHis({ ...filterHis, dateFrom: value });
                  }}
                />
              </Col>
              <Col
                md={1}
                style={{ width: '2%' }}
                className="d-flex align-items-center"
              >
                <label className="form-label mb-0">To</label>
              </Col>
              <Col md={2}>
                <InputDatePicker
                  column="dateTo"
                  selected={filterHis.dateTo}
                  handleChange={(col, value) =>
                    setFilterHis({ ...filterHis, dateTo: value })
                  }
                />
              </Col>
            </Row>

            {/* Supplier name */}
            <Row className="mb-2">
              <Col md={1} className="d-flex align-items-center">
                <label className="form-label mb-0">Supplier name</label>
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Enter supplier..."
                  value={filterHis.supplierName}
                  onChange={e =>
                    setFilterHis({ ...filterHis, supplierName: e.target.value })
                  }
                />
              </Col>
            </Row>

            {/* WPO ref */}
            <Row className="mb-2">
              <Col md={1} className="d-flex align-items-center">
                <label className="form-label mb-0">WPO Ref</label>
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Enter WPO ref..."
                  value={filterHis.wpoRef}
                  onChange={e =>
                    setFilterHis({ ...filterHis, wpoRef: e.target.value })
                  }
                />
              </Col>
            </Row>

            {/* Part code */}
            <Row className="mb-2">
              <Col md={1} className="d-flex align-items-center">
                <label className="form-label mb-0">Part code</label>
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Enter part code..."
                  value={filterHis.partCode}
                  onChange={e =>
                    setFilterHis({ ...filterHis, partCode: e.target.value })
                  }
                />
              </Col>
            </Row>

            {/* Search button */}
            <Row>
              <Col md={2}>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleSearchHistoric}
                >
                  Search
                </button>
              </Col>
            </Row>
          </Form>
        </Card.Header>

        <Card.Body className="p-2">
          <DeliveryDiscrepancyTable
            mode="historic"
            data={historicData}
            paging={historicPaging}
            total={historicTotal}
            nextPage={hisNextPage}
            previousPage={hisPreviousPage}
            gotoPage={hisGotoPage}
            reloadFn={() => {}}
          />
        </Card.Body>
      </Card>
    </>
  );
}
